import { c as _c } from "react/compiler-runtime";
import { PromotionalCardBase } from "../card-base";
import { PromotionalCardProps, REVIEW_URLS } from "../types";

// Quora logo icon
function QuoraIcon(t0) {
  const $ = _c(3);
  const {
    className
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M12.738 17.742c-.69-1.188-1.588-2.314-2.938-2.314-.349 0-.717.074-1.043.241l-.452-.906c.624-.498 1.597-.79 2.606-.79 1.834 0 2.98.89 3.925 2.229.377-1.015.57-2.262.57-3.756 0-4.429-1.577-7.159-4.692-7.159-3.11 0-4.701 2.73-4.701 7.159 0 4.408 1.591 7.101 4.701 7.101.533 0 1.026-.068 1.483-.19l.541.385zm-1.024 1.95c-.58.097-1.167.145-1.758.145C5.295 19.837 2 16.179 2 11.446 2 6.71 5.296 3 9.956 3c4.665 0 7.952 3.71 7.952 8.446 0 2.476-.817 4.653-2.082 6.175.659 1.086 1.424 1.842 2.34 1.842.667 0 1.106-.293 1.421-.685l.833.979c-.644.895-1.574 1.243-2.601 1.243-1.7 0-2.935-1.012-4.105-3.308z" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== className) {
    t2 = <svg className={className} viewBox="0 0 24 24" fill="currentColor">{t1}</svg>;
    $[1] = className;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}
export function QuoraReviewCard(t0) {
  const $ = _c(3);
  const {
    className
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <QuoraIcon className="w-full h-full" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== className) {
    t2 = <PromotionalCardBase icon={t1} title="Share Your Story on Quora" description="Help others learn from your home-buying journey with Settlin" ctaText="Answer on Quora" href={REVIEW_URLS.QUORA} className={className} iconColor="text-[#B92B27]" />;
    $[1] = className;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}